import { useEquipmentStore } from '@/store/Equipment/product'
const store = useEquipmentStore()
export default function persistStore() {
  store.persisit()
}
